import itemTypeComponent from './item_type.component';
import itemTypeCreate from './create';
import ItemTypeEdit from './edit';
import ItemTypeAll from './all';

let itemTypeModule = angular.module('itemType', [
    itemTypeCreate,
    ItemTypeEdit,
    ItemTypeAll
  ])

  .component('itemType', itemTypeComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      
      .state('items-type.create', {
        url: '/create',
        component: 'itemTypeCreate'
      })

      .state('items-type.edit', {
        url: '/edit/:id',
        component: 'itemTypeEdit'
      })

      .state('items-type.all', {
        url: '/all/:page',
        component: 'itemTypeAll'
      })
  })
  .name;

export default itemTypeModule;


// WEBPACK FOOTER //
// ./client/app/components/item_type/index.js